export interface CarritoItem {
    productoId: string;
    nombre: string;
    precio: number;
    precioOriginal: number;
    imagen: string | null;
    cantidad: number;
    stockDisponible: number;
}

export interface CarritoState {
    items: CarritoItem[];
}

export const CARRITO_ADD_ITEM = 'CARRITO_ADD_ITEM';
export const CARRITO_REMOVE_ITEM = 'CARRITO_REMOVE_ITEM';
export const CARRITO_UPDATE_CANTIDAD = 'CARRITO_UPDATE_CANTIDAD';
export const CARRITO_CLEAR = 'CARRITO_CLEAR';

export interface AddItemAction {
    type: typeof CARRITO_ADD_ITEM;
    payload: CarritoItem;
}
export interface RemoveItemAction {
    type: typeof CARRITO_REMOVE_ITEM;
    payload: string; // productoId
}
export interface UpdateCantidadAction {
    type: typeof CARRITO_UPDATE_CANTIDAD;
    payload: { productoId: string; cantidad: number };
}
export interface ClearCarritoAction {
    type: typeof CARRITO_CLEAR;
}

export type CarritoActionTypes = AddItemAction | RemoveItemAction | UpdateCantidadAction | ClearCarritoAction;
